import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';

import { Observable, of } from 'rxjs';
import { catchError, mergeMap } from 'rxjs/operators';

@Injectable()
export class DefaultInterceptor implements HttpInterceptor {
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (localStorage.getItem('id_token') && req.url.indexOf('anon/environments') == -1 && req.url.indexOf('system/cognito/token') == -1) {
            const Authorization = `Bearer ${localStorage.getItem('id_token')}`;
            req = req.clone({ setHeaders: { Authorization } });
        }
        req = req.clone({
            withCredentials: false
        });
        const requestParamKeys = req.params.keys();
        for (const itemParamKey of requestParamKeys) {
            const itemParamValue = req.params.get(itemParamKey)
            if (itemParamValue == null || itemParamValue == undefined) {
                req = req.clone({ params: req.params.delete(itemParamKey) })
            }
        }
        return next.handle(req).pipe(
            mergeMap((event: any) => {
                return of(event);
            }),
            catchError((err: HttpErrorResponse) => {
                return of(err);
            })
        );
    }
}
